import {PaymentProviderConfiguration} from '../models/payments/paymentProviderConfiguration.model';
import {JobPayment} from '../models/payments/jobPayment.model';

export namespace Payments {
  export class GetProviders {
    static readonly type = '[Payments api] Get Providers';

    constructor(public force: boolean = false) {
    }
  }

  export class GetProvider {
    static readonly type = '[Payments api] Get Provider';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateProvider {
    static readonly type = '[Payments api] Create Provider';

    constructor(public provider: PaymentProviderConfiguration) {
    }
  }

  export class UpdateProvider {
    static readonly type = '[Payments api] Update Provider';

    constructor(public provider: PaymentProviderConfiguration) {
    }
  }

  export class DeleteProvider {
    static readonly type = '[Payments api] Delete Provider';

    constructor(public provider: PaymentProviderConfiguration) {
    }
  }

  export class GetRegionPaymentProviders {
    static readonly type = '[Payments api] Get Region Payments Providers';

    constructor(public force: boolean = false) {
    }
  }

  export class GetJobPayment {
    static readonly type = '[Payments api] Get Job Payment';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobPaymentLocal {
    static readonly type = '[Payments local] Update Job Payment Local';

    constructor(public jobPayment: JobPayment) {
    }
  }

  export class UpdateJobPaymentApi {
    static readonly type = '[Payments api] Update Job Payment Api';

    constructor(public id: string, public jobPayment: JobPayment) {
    }
  }
}

